import { AddReviewsComponent } from './../add-reviews/add-reviews.component';
import { SelectedVehicleService } from 'src/app/services/selectedVehicle.service';
import { TranslateService } from '@ngx-translate/core';
import { Vehicle } from 'src/app/models/Vehicle';
import { BookingService } from './../../../services/booking.service';
import { LoginModalBodyComponent } from './../login-modal-body/login-modal-body.component';
import { ReviewsModalBodyComponent } from './../../search-location/reviews-modal-body/reviews-modal-body.component';
import { SearchService } from 'src/app/services/search.service';
import { Component, Input, OnInit, ChangeDetectorRef, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { faChevronCircleLeft, faChevronCircleRight, faBriefcase, faGasPump, faUser, faMapMarkerAlt, faCar, faKey, faTags, faDollarSign, faRoad, faBatteryHalf, faBan } from '@fortawesome/free-solid-svg-icons';

import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VehicleSearchTypeEnum } from 'src/app/models/enums/VehicleSearchTypeEnum';
import { VehicleCardEnum } from 'src/app/models/enums/VehicleCardEnum';
import { Console } from 'console';
import { ViewBookingModel } from 'src/app/models/Booking/ViewBookingModel';
import { ActivatedRoute, Router } from '@angular/router';
import { AttachmentScopesEnum, AttachmentTypeEnum } from 'src/app/models/enums/Attachment/AttachmentEnum';
import { AttachmentService } from 'src/app/services/attachment.service';
import { IconService } from './../../../services/icon.service';
import { Subscription } from 'rxjs';




@Component({
  selector: 'booking-vehicle-type',
  templateUrl: './booking-vehicle-type.component.html',
  styleUrls: ['./booking-vehicle-type.component.scss']
})
export class BookingVehicleTypeComponent implements OnInit,OnDestroy {
  @Input() pageType: number;
  @Input() currentStepIndex:any;
  stepIndex:number=0;
  @Output() onBookNow = new EventEmitter();
  MakeModelYearSearch: boolean = false;
  vehicleSearch: boolean = false;
  classSearch: boolean = false;
  math = Math;
  faBriefcase = faBriefcase;
  faGasPump = faGasPump;
  faUser = faUser;
  faMapMarkerAlt = faMapMarkerAlt;
  faCar = faCar;
  faKey = faKey;
  faTags = faTags;
  faDollarSign = faDollarSign;
  faRoad = faRoad;
  faBatteryHalf = faBatteryHalf;
  faBan = faBan;
  faChevronCircleLeft = faChevronCircleLeft;
  faChevronCircleRight = faChevronCircleRight;

  vehicle:Vehicle;
  currency;
  duration;

  isLinear = true;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  viewBooking: ViewBookingModel;

  subscriptions:Subscription[]=[];

    constructor(
    private formBuilder: FormBuilder,
    private matIconRegistry: MatIconRegistry,
    protected cdr: ChangeDetectorRef,
    private searchService: SearchService,
    private bookingService: BookingService,
    private domSanitizer: DomSanitizer,
    public translateService: TranslateService,
    private _formBuilder: FormBuilder,
    service: SearchService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private attachmentService:AttachmentService,
    private iconService:IconService,
    private attachmnetService:AttachmentService,
    private selectedVehicleService:SelectedVehicleService,

    ) {
      // this.matIconRegistry.addSvgIcon(
      //   "car-gear",
      //   this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.carGearIcon)
      // );
      // this.matIconRegistry.addSvgIcon(
      //   "car-door",
      //   this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.carDoorIcon)
      // );
    //this.vehicle = searchService.getVehicle();
    this.currency = searchService.getCurrency();


  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(item =>{
      item.unsubscribe();
    })
  }


  public get vehicleCardEnum(): typeof VehicleCardEnum {
    return VehicleCardEnum;
  }
  get attachmentScopesEnum(){
    return AttachmentScopesEnum
  }
  get attachmentTypeEnum(){
    return AttachmentTypeEnum;
  }


  setVehicleClass(type: number) {
    //To be Updated
    //Todo: cache the type for now only support one static type
    this.classSearch = false;
    this.MakeModelYearSearch = false;
    this.vehicleSearch = false;

     if (type != null) {
      //this.bookingService.searchAvailableVehicleFilterType
      switch (type) {
        case VehicleSearchTypeEnum.classSearch:
          this.classSearch = true;
          break
        case VehicleSearchTypeEnum.MakeModelYearSearch:
          this.MakeModelYearSearch = true;
          break
        case VehicleSearchTypeEnum.vehicleSearch:
          this.vehicleSearch = true;
          break
        default:
          this.vehicleSearch = true;
          break;


      }
    }
    else{
      if(this.vehicle.vehicleID!=null){
        this.vehicleSearch=true;
      }
      else if(this.vehicle.makeID!=null&&this.vehicle.modelID!=null&&this.vehicle.year!=null){
        this.MakeModelYearSearch=true;
      }
      else{
        this.classSearch=true;
      }
    }


  }
  openAddReview() {
    const dialogConfig = new MatDialogConfig();
    this.dialog.open(AddReviewsComponent,  { panelClass: 'add-review-modal' });
  }


  ngOnInit() {


    if(this.currentStepIndex!=null){
      this.subscriptions.push(this.currentStepIndex.subscribe(res =>{
        if(res!=null){
          this.stepIndex=res;
        }

      }))
    }


    this.subscriptions.push(this.selectedVehicleService.vehicle.subscribe(res => {


      if (res != null) {
        this.vehicle = res;
        ;
        this.setVehicleClass(this.bookingService.searchAvailableVehicleFilterType);
      }
      else {
        let _cahcedVehicle = this.selectedVehicleService.getCachedVehicle();
        if (_cahcedVehicle != null) {
          this.vehicle = _cahcedVehicle;
          this.setVehicleClass(_cahcedVehicle.searchAvailableVehicleFilterType);
        }
        else {
          //Todo: Redirect to home page
        }
      }
      this.subscriptions.push(this.bookingService.viewBookingModel.subscribe(res=>{

        if(res!=null){
          this.viewBooking=res;
          this.vehicle.durationUnitName=res.durationUnitName;
        }
      }))
    }));
    this.subscriptions.push(this.selectedVehicleService.findYourIdealCardvehicle.subscribe(res => {



      if (res != null) {
        this.vehicle = res;
        ;
        this.setVehicleClass(this.bookingService.searchAvailableVehicleFilterType);
      }
      else {
        let _cahcedVehicle = this.selectedVehicleService.getCachedVehicle();
        if (_cahcedVehicle != null) {
          this.vehicle = _cahcedVehicle;
          this.setVehicleClass(_cahcedVehicle.searchAvailableVehicleFilterType);
        }
        else {
          //Todo: Redirect to home page
        }
      }
      this.subscriptions.push(this.bookingService.viewBookingModel.subscribe(res=>{

        if(res!=null){
          this.viewBooking=res;
          this.vehicle.durationUnitName=res.durationUnitName;
        }
      }))
    }));

    this.subscriptions.push(this.bookingService.vehicleReservationCaseDetailsModel.subscribe(res => {




      if (res != null) {
      this.vehicle.vehiclePrice=res.vehicleReservationCaseRentalPeriodModel[0].totalRentalPrice;
      this.vehicle.durationUnitName=res.vehicleReservationCaseRentalPeriodModel[0].durationUnitNameFull;
      this.vehicle.vehicleClass=res.vehicleClassName;
      }

    }));

  }

  bookNow(){

    this.onBookNow.emit(true);

  }

  openDialog(){

  }
  openReviewDialog(vehicle) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      vehicle: vehicle
    }
    this.dialog.open(ReviewsModalBodyComponent, dialogConfig);
  }

}
